import { Badge } from "react-bootstrap";


const HeaderEvento = ({ evento, descripcion, created, log_name }) => {

    let config = {}

    if (log_name == "error") {
        config.bgHeader = "bg-danger"
    } else {
        if (evento == "created") {
            config.bgHeader = "bg-primary"
        } else {
            config.bgHeader = "bg-warning"
        }
    }

    if (log_name == "error") {
        if (evento == "created") {
            config.bgTipo = "bg-primary p-2 rounded"
        } else {
            config.bgTipo = "bg-warning p-2 rounded"
        }
    }

    // console.log(config)


    // console.log(log_name)
    return (
        <>
            <div className={`${config.bgHeader} d-flex align-items-center gap-4 py-2 px-4 w-100`}>
                <h4 className={`text-white m-0 ${config.bgTipo}`} >{evento}</h4>
                <span className="text-white">-</span>
                <p className="text-white m-0">{created}</p>
                <span className="text-white">-</span>
                <p className="text-white m-0">{descripcion}</p>
            </div>
            {/* {evento == "updated" && <Badge bg="warning" className={`m-0 ${size == "lg" ? "fs-5" : "fs-6"}`} >UPDATED</Badge>} */}

        </>
    );
}
export default HeaderEvento
    ;